<template>
  <!-- 面料 -->
  <div class="fabricReportBasic">
    <div class="reportBasic-con">
      <a-spin :spinning="spinning">
        <a-tabs defaultActiveKey="1" @change="callback">
          <a-tab-pane
            :tab="$tc('lang.FabricReport.GENERAL_INFORMATION')"
            key="1"
          >
            <basic-information />
          </a-tab-pane>
          <a-tab-pane :tab="$tc('lang.FabricReport.BULK_SUMMARY')" key="2">
            <description-of-goods />
          </a-tab-pane>
          <a-tab-pane
            :tab="$tc('lang.FabricReport.PACKING_INFORMATION')"
            key="3"
          >
            <description-of-pack />
          </a-tab-pane>
          <a-tab-pane :tab="$tc('lang.FabricReport.WORKMANSHIP')" key="4">
            <product-details />
          </a-tab-pane>
          <a-tab-pane :tab="$tc('lang.FabricReport.Product_Width')" key="5">
            <cart></cart>
          </a-tab-pane>
          <a-tab-pane
            :tab="$tc('lang.FabricReport.DATA_MEASUREMENT_FIELD_TEST')"
            key="6"
          >
            <process-monitoring></process-monitoring>
          </a-tab-pane>
          <a-tab-pane :tab="$tc('lang.FabricReport.DEFECTIVES_LIST')" key="7">
            <closures></closures>
          </a-tab-pane>
          <a-tab-pane :tab="$tc('lang.FabricReport.Brief_Findings')" key="8">
            <general-estimate />
          </a-tab-pane>
        </a-tabs>
      </a-spin>
    </div>
    <!-- <div class="bottom-active">
      <div>
        <a-button type="primary" @click="goBack">立即返回</a-button>
      </div>
    </div> -->
  </div>
</template>
<script>
import basicInformation from './fabricComponents/basicInformation';
import descriptionOfGoods from './fabricComponents/descriptionOfGoods';
import descriptionOfPack from './fabricComponents/descriptionOfPack';
import productDetails from './fabricComponents/productDetails';
import generalEstimate from './fabricComponents/generalEstimate';
import cart from './fabricComponents/cart';
import processMonitoring from './fabricComponents/processMonitoring';
import closures from './fabricComponents/closures';
export default {
  data() {
    return {
      id: this.$route.query.id,
      spinning: false,
    };
  },
  created() {
    this.getDetail();
  },
  components: {
    descriptionOfGoods, // 货物描述
    descriptionOfPack, // 包装描述
    productDetails, // 产品细节
    cart,
    closures,
    processMonitoring,
    basicInformation, // 基本信息
    generalEstimate, //总概
  },
  computed: {
    fabricDetails: {
      get() {
        return this.$store.state.report.fabricDetails;
      },
      set(val) {
        this.$store.commit('report/save', { fabricDetails: val });
      },
    },
  },
  methods: {
    callback(key) {
      console.log(key);
    },
    goBack() {
      this.$router.back(-1);
    },

    getDetail() {
      this.spinning = true;
      this.$http
        .post('/hzwmj/workorder-fabricreport/getFabricInfo', {
          id: this.id,
        })
        .then(data => {
          if (data.data) {
            this.fabricDetails = data.data;
            this.spinning = false;
            this.getImg();
          } else {
            this.fabricDetails = {};
            this.spinning = false;
          }
        })
        .catch(() => {
          this.fabricDetails = {};
          this.spinning = false;
        });
    },
    getImg() {
      this.$store.dispatch('report/getfabricImg', this.fabricDetails.freportId);
      // this.$store.dispatch('report/getfabricImg', 'VM320920190924095848');
    },
  },
};
</script>

<style lang="less">
.fabricReportBasic {
  height: calc(100vh - 190px);
  overflow: hidden;
  text-align: left;
  margin-top: 35px;
  li {
    list-style: none;
  }

  .reportBasic-subTitle {
    background-color: #f6f6f6;
    padding: 5px 10px;
    margin: 10px 0;
  }
  .button-group {
    text-align: right;
    button {
      margin: 0 5px;
    }
  }
  .reportBasic-con {
    .ant-tabs-tabpane {
      padding: 0 10px 30px;
      height: calc(100vh - 300px);
      overflow-y: auto;
    }
  }
}
</style>
